import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jobjectinit(){

  const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
return(
    <div>
       <Sides/>
       <Helmet>
 
  <title>Java object initialization tutorial For Beginners</title>
<meta name="description" content="Java object initialization tutorial for beginners.CodeExampler provides Multiple Programming Examples for Beginners,CodeExampler provides Free Online Tutorials for beginners and questions of all technology like java tutorial, Java tutorial,Java tutorial for beginners in deeply knowledge With Deeply" />
<meta name="keywords" content="codeexampler,programming language,rrefrence variable,using method in java,using constructor in java,tutorial for begineers,java object initialization,java constructor initialization list,java object initialization like c#,java initialize object in loop,java initialize object outside constructor,object initialization through method in java,java object initialization process,java object initialization without new,object initialization in java javatpoint,java new object array initialization" />
<link rel="canonical" href="https://www.codeexampler.com/java-object-initialize" />
</Helmet>


<div className='lg:pl-56'>

    <h1 className="m-4 mh1">Object initialization in java</h1>
    <div className="first">
        <a href="/java-user-defined-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-constructor">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    <h2 className="mt-4 mh2">1, Reference variable in java<br/>
2, Using Method in java<br/>
3, Using Constructor in java</h2>

<h2 className="mt-4 mh2">Reference Variable in Java:</h2>


<h2 className="headings">Q-Write Program the reference variable in java example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Human </span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;int </span>
              <span className="qwerty-4">age; </span>
              {"\n"}
              <span className="qwerty-5">&nbsp;&nbsp;String </span>
              <span className="qwerty-4">name; </span>
              {"\n"}
          
          {"\n"}
                          
           
            <span className="qwerty-7">&nbsp;&nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"} 
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Human</span>
          <span className="qwerty-3"> h</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-5">new </span>
          <span className="qwerty-4">Human</span>
          <span className="qwerty-1">();</span>
          {"\n"} 
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;h</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">age</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">160208;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;h</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">name</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">"codeExampler";</span>
          
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-3">h</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">age</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4">""</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3">h</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">name</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          
    
    
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"} 
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;160208</span>
          <span className="qwerty-5">&nbsp;codeExampler</span>
          {"\n"}             
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="headings">Q-Write a program reference variable in java example?</h2>
<div
  style={{
    background: "#0f0e33",
    width: "94%",
    marginLeft: "3%",
    paddingLeft: "2%",
    borderRadius: "20px",
  }}
>
  <pre style={{ maxHeight: "500vh" }}>
    <code>
      {"\n"}
      <span className="qwerty-5">class</span>
      <span className="qwerty-4"> school </span>
      {"\n"}
      <span className="qwerty-3">&#123; </span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> teachers;</span>
      <span className="qwerty-2"> {`// no of teachers`}</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> students;</span>
      <span className="qwerty-2"> {`// no of students`}</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;int</span>
      <span className="qwerty-4"> peon;</span>
      <span className="qwerty-2"> {`// no of poem`}</span>
      {"\n"}
      <span className="qwerty-2"> &nbsp;{`//this class declares an object of type school.`}</span>
      
      {"\n"}{"\n"}
                      
       
        <span className="qwerty-7">&nbsp; &nbsp;public </span>
      <span className="qwerty">static </span>
      <span className="qwerty-3">void </span>
      <span className="qwerty-8">main </span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-2">String</span>
      <span className="qwerty-1">[] </span>
      <span className="qwerty-1">args</span>
      <span className="qwerty-1">) </span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
      {"\n"} 
      <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-5">new </span>
      <span className="qwerty-4">school</span>
      <span className="qwerty-1">();</span>
      {"\n"} 
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">40;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">500;</span>
      {"\n"}
      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8"> = </span>
      <span className="qwerty-1">20;</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`// This dot operator (.) is used to access the member`}</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">teachers</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "teachers in this school"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">students</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "students in this school"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
      <span className="qwerty-4">"there are "</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-3"> sch</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-4">peon</span>
      <span className="qwerty-8">+</span>
      <span className="qwerty-4"> "peon in this school"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
     




      <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
      {"\n"} 
      <span className="qwerty-3">&#125; </span>
        {"\n"}





   
    </code>
  </pre>        
</div>

<div>
  <h3 className="headings">Output</h3>
  <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
    <pre style={{ maxHeight: '500vh' }}>
      <code className="python hljs">
      {"\n"}
      <span className="qwerty-3">&nbsp;there are 40 teachers in this school</span>
      {"\n"}   
      <span className="qwerty-3">&nbsp;there are 500 students in this school</span>
      {"\n"} 
      <span className="qwerty-3">&nbsp;there are 20 peon in this school</span>
      {"\n"}            
        </code>{"   "}
        </pre>
  </div>
</div>




<h2 className="headings">Q-Write a Program create 2 object class?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> school </span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;int</span>
          <span className="qwerty-4"> teachers;</span>
          <span className="qwerty-2"> {`// no of teachers`}</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;int</span>
          <span className="qwerty-4"> students;</span>
          <span className="qwerty-2"> {`// no of students`}</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;int</span>
          <span className="qwerty-4"> peon;</span>
          <span className="qwerty-2"> {`// no of poem`}</span>
          {"\n"}
          <span className="qwerty-2"> &nbsp;{`//this class declares an object of type school.`}</span>
          
          {"\n"}{"\n"}
                          
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"} 
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
          <span className="qwerty-3"> sch1</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-5">new </span>
          <span className="qwerty-4">school</span>
          <span className="qwerty-1">();</span>
          {"\n"} 
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
          <span className="qwerty-3"> sch2</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-5">new </span>
          <span className="qwerty-4">school</span>
          <span className="qwerty-1">();</span>
          {"\n"} 
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//Sch1 and sch2 Both are different objects`}</span>{"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//assigns value inside the sch1 fields`}</span>
          {"\n"}{"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch1</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">teachers</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">40;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch1</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">students</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">500;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch1</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">peon</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">20;</span>
          {"\n"}
    
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//assigns value inside the sch2 fields`}</span>
          {"\n"}{"\n"}
    
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch2</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">teachers</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">20;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch2</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">students</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">250;</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch2</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">peon</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-1">10;</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`// This dot operator (.) is used to access the member`}</span>
          {"\n"}{"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//sch1`}</span>
          {"\n"}{"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"there are "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3"> sch1</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">teachers</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4"> "teachers in this school 1"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"there are "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3"> sch1</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">students</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4"> "students in this school 1"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"there are "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3"> sch1</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">peon</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4"> "peon in this school 1"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
         
    
    
    
    
          {"\n"}{"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`//sch2`}</span>
          {"\n"}{"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"there are "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3"> sch2</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">teachers</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4"> "teachers in this school 2"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"there are "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3"> sch2</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">students</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4"> "students in this school 2"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">out</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-2">println</span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-4">"there are "</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-3"> sch2</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">peon</span>
          <span className="qwerty-8">+</span>
          <span className="qwerty-4"> "peon in this school 2"</span>
          <span className="qwerty-1">);</span>
          {"\n"}
         
    
    
    
    
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"} 
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;there are 40 teachers in this school </span>
          {"\n"}   
          <span className="qwerty-3">&nbsp;there are 500 students in this school 1</span>
          {"\n"} 
          <span className="qwerty-3">&nbsp;there are 20 peon in this school 1</span>
          {"\n"}  {"\n"}  
          <span className="qwerty-3">&nbsp;there are 20 teachers in this school 2</span>
          {"\n"}   
          <span className="qwerty-3">&nbsp;there are 250 students in this school 2</span>
          {"\n"} 
          <span className="qwerty-3">&nbsp;there are 10 peon in this school 2 </span>
          {"\n"}            
            </code>{"   "}
            </pre>
      </div>
    </div>



<h2 className="mt-4 mh2">2, Using Method:</h2>



<h2 className="headings">Q-Write Program the reference variable in java example?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
          {"\n"}
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> Human </span>
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
          <span className="qwerty-2">&nbsp;&nbsp;int </span>
              <span className="qwerty-4">teachers; </span>
              {"\n"}
              <span className="qwerty-2">&nbsp;&nbsp;int </span>
              <span className="qwerty-4">students; </span>
              {"\n"}


              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;void </span>
              <span className="qwerty-8">numbers</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-2">int </span>
              <span className="qwerty-4">t </span>
              <span className="qwerty-8">,</span>
              <span className="qwerty-2">int </span>
              <span className="qwerty-4">s </span>
              <span className="qwerty-1">)</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}


              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;teachers </span>
              <span className="qwerty-8">= </span>
              <span className="qwerty-4">t ;</span>
              {"\n"}
              <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;students </span>
              <span className="qwerty-8">= </span>
              <span className="qwerty-4">s ;</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}

              <span className="qwerty-3">&nbsp;&nbsp;void </span>
              <span className="qwerty-8">show</span>
              <span className="qwerty-1">()</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp; &#123; </span>
              {"\n"}


              
              <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">out</span>
              <span className="qwerty-8">.</span>
              <span className="qwerty-2">println</span>
              <span className="qwerty-1">(</span>
              <span className="qwerty-4">teachers </span>
              <span className="qwerty-8">+</span>
              <span className="qwerty-4">""</span>
              <span className="qwerty-8">+</span>
              <span className="qwerty-4">students </span>
              <span className="qwerty-1">);</span>
              {"\n"}
              <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
              {"\n"}{"\n"}   
          
          {"\n"}
                          
           
            <span className="qwerty-7">&nbsp;&nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>
          {"\n"} 
          <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;school</span>
          <span className="qwerty-3"> sch</span>
          <span className="qwerty-8"> = </span>
          <span className="qwerty-5">new </span>
          <span className="qwerty-4">school</span>
          <span className="qwerty-1">();</span>
          {"\n"} 
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;h</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">name</span>
          <span className="qwerty-1">(40,400);</span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sch</span>
          <span className="qwerty-8">.</span>
          <span className="qwerty-4">show</span>
          <span className="qwerty-1">();</span>
          {"\n"}
    
    
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>
          {"\n"} 
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
    
    
    
    
       
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;40</span>
          <span className="qwerty-5">&nbsp;400</span>
          {"\n"}             
            </code>{"   "}
            </pre>
      </div>
    </div>
    


  <h1 className="mt-5">  </h1>
  <div className="back">
        <a href="/java-user-defined-function">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-constructor">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
        </div>
    </div>
)

}
export default Jobjectinit;